import React from 'react';
import { Link } from 'react-router-dom'; // Import Link for navigation

const Game = () => {
  return (
    <div className="bg-slate-900 text-white min-h-screen flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-4xl text-center mb-8">
        <h1 className="text-4xl font-bold mb-4">Meditative Snake</h1>
        <p className="text-slate-400">Use arrow keys to steer, and Shift to boost. Find the others.</p>
        <Link to="/" className="text-blue-400 hover:text-blue-300 transition-colors mt-4 inline-block">
          ← Back to Portfolio
        </Link>
      </div>

      {/* This is the responsive iframe that embeds your game */}
      <div style={{
        position: 'relative',
        width: '100%',
        maxWidth: '800px',
        paddingBottom: '75%', // Creates a 4:3 aspect ratio
        height: 0,
        overflow: 'hidden',
        background: '#080808',
        borderRadius: '8px'
      }}>
        <iframe 
          src="/snake-game.html" 
          title="Meditative Snake Game"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 0
          }}
          allowFullScreen=""
        ></iframe>
      </div>
    </div>
  );
};

export default Game;
